export default __webpack_public_path__ + "static/media/PR.d3dfbe67.svg";